import { Box, LinearProgress, Alert } from '@mui/material';

import { ValidationError } from '@/features/companies/utils/validations';

interface HeaderMessageProps {
  validationState: {
    errors: ValidationError[];
    isValid: boolean;
    isSubmitting: boolean;
  };
  submitMessage: {
    type: 'success' | 'error';
    message: string;
  } | null;
  setSubmitMessage: (
    submitMessage: {
      type: 'success' | 'error';
      message: string;
    } | null
  ) => void;
}

const HeaderMessage = ({
  validationState,
  submitMessage,
  setSubmitMessage,
}: HeaderMessageProps) => {
  return (
    <>
      {/* Loading Indicator */}
      {validationState.isSubmitting && (
        <Box sx={{ mb: 2 }}>
          <LinearProgress />
        </Box>
      )}

      {/* Submit Status Messages */}
      {submitMessage && (
        <Alert severity={submitMessage.type} sx={{ mb: 3 }} onClose={() => setSubmitMessage(null)}>
          {submitMessage.message}
        </Alert>
      )}

      {/* General Error Messages */}
      {validationState.errors.some((error) => error.field === 'general') && (
        <Alert severity='error' sx={{ mb: 3 }}>
          {validationState.errors.find((error) => error.field === 'general')?.message}
        </Alert>
      )}
    </>
  );
};

export default HeaderMessage;
